import ContentPanel from "./functional";
export default ContentPanel;
